module.exports = __webpack_public_path__ + "img/tui.8482aaab.png";